import { ActionLink } from "@diffex/ui";

import { productConfig } from "../config";
import { PublicLayout } from "./PublicLayout";
import { RequestId } from "./RequestId";

type PublicGateProps = {
  eyebrow: string;
  title: string;
  detail: string;
  requestId?: string;
  retry?: () => void;
};

export function PublicGate({ eyebrow, title, detail, requestId, retry }: PublicGateProps) {
  return (
    <PublicLayout>
      <p className="eyebrow">{eyebrow}</p>
      <h1>{title}</h1>
      <p>{detail}</p>
      {requestId ? <RequestId value={requestId} /> : null}
      <div className="public-actions">
        {retry ? (
          <button type="button" className="action-link action-link-primary" onClick={retry}>
            Try again
          </button>
        ) : (
          <ActionLink href="/login?return_to=/">Sign in</ActionLink>
        )}
        <ActionLink href={productConfig.marketingOrigin} tone="secondary">
          Return to Diffex
        </ActionLink>
      </div>
    </PublicLayout>
  );
}
